import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalibrationReferenceDevicesService {

  constructor(private httpClientService: HttpClientService) { }

  async calibrationReferenceDevices(deviceId, calibrationId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.CalibraitonReferenceDevice
    }, {
      deviceId:deviceId,
      calibrationId:calibrationId
    });
    return await firstValueFrom(observable);
  }
}
